import type z from 'zod';

export function createLocalStore<S extends z.ZodType>(path: string, schema: S) {
  return {
    write(o: z.core.output<S>) {
      try {
        localStorage.setItem(path, JSON.stringify(schema.encode(o)));
      } catch {}
    },
    read() {
      try {
        const i = localStorage.getItem(path);
        if (i === null) return;
        return schema.parse(JSON.parse(i));
      } catch {}
    },
    remove() {
      localStorage.removeItem(path);
    },
  };
}
